import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import BtnLoader from 'Components/Common/Loader/BtnLoader';
import { loadDecrypted } from "Common Usage/localStorageUtils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 400,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: 8,
    boxShadow: 24,
    p: 4,
};

const EditPopUp = ({ editPopupOpen, handleEditClose, selectedItem }) => {
    const [idBtnLoading, setIdBtnLoading] = useState(false);

    const handelSubmit = () => {
        setIdBtnLoading(true);

        // Update user: unblock
        let data = JSON.stringify({
            "is_BlockedUser": "false"
        });

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/users/update/${selectedItem?._id}`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then(async (response) => {
                console.log(JSON.stringify(response.data));

                // --- Create staff activity log for unblock ---
                try {
                    const staffData = loadDecrypted("HeartConnect-StaffData");
                    const staffId = staffData?._id || staffData?.id || "";
                    const staffName = staffData?.fullName || staffData?.name || "Unknown";

                    if (staffId) {
                        await axios.post(
                            `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
                            {
                                staff: staffId,
                                action: "UNBLOCK_USER",
                                description: `Staff ${staffName} unblocked user ${selectedItem?.fullName} (${selectedItem?._id})`,
                            },
                            { headers: { "Content-Type": "application/json" } }
                        );
                    }
                } catch (logErr) {
                    console.error("Failed to create staff activity log:", logErr);
                }
                // -------------------------------------------

                setIdBtnLoading(false);
                handleEditClose();
            })
            .catch((error) => {
                console.log(error);
                setIdBtnLoading(false);
                handleEditClose();
            });
    };

    return (
        <Modal
            open={editPopupOpen}
            onClose={handleEditClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="w-full">
                    <div className="flex items-center mb-4">
                        <img
                            src={selectedItem?.selected_Avatar}
                            alt="Avatar"
                            className="w-14 h-14 rounded-full mr-2"
                        />
                        <h2 className="text-xl font-semibold tracking-wide">
                            {selectedItem?.fullName}
                        </h2>
                    </div>
                    <p className="mb-6 tracking-wide">
                        Are you sure you want to Unblock this user?
                    </p>
                    <div className="flex justify-end space-x-4 tracking-wide">
                        <button
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                            onClick={() => handleEditClose()}
                        >
                            Cancel
                        </button>
                        {idBtnLoading ? (
                            <button className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded">
                                <BtnLoader />
                            </button>
                        ) : (
                            <button
                                className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded"
                                onClick={() => handelSubmit()}
                            >
                                Unblock
                            </button>
                        )}
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default EditPopUp;







// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';
// import axios from 'axios';
// import BtnLoader from 'Components/Common/Loader/BtnLoader';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%',
//     maxWidth: 400,
//     bgcolor: 'background.paper',
//     border: 'none',
//     borderRadius: 8,
//     boxShadow: 24,
//     p: 4,
// };

// const EditPopUp = ({ editPopupOpen, handleEditClose, selectedItem }) => {
//     const [idBtnLoading, setIdBtnLoading] = useState(false)


//     const handelSubmit = () => {
//         setIdBtnLoading(true)
//         let data = JSON.stringify({
//             "is_BlockedUser": "false"
//         });

//         let config = {
//             method: 'put',
//             maxBodyLength: Infinity,
//             url: `${process.env.REACT_APP_API_URL}/users/update/${selectedItem?._id}`,
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             data: data
//         };

//         axios.request(config)
//             .then((response) => {
//                 console.log(JSON.stringify(response.data));
//                 setIdBtnLoading(false)
//                 handleEditClose();
//             })
//             .catch((error) => {
//                 console.log(error);
//                 setIdBtnLoading(false)
//                 handleEditClose();
//             });

//     }


//     return (
//         <Modal
//             open={editPopupOpen}
//             onClose={handleEditClose}
//             aria-labelledby="modal-modal-title"
//             aria-describedby="modal-modal-description"
//         >
//             <Box sx={style}>
//                 <div className="w-full">
//                     <div className="flex items-center mb-4">
//                         <img
//                             src={selectedItem?.selected_Avatar}
//                             alt="Avatar"
//                             className="w-14 h-14 rounded-full mr-2"
//                         />
//                         <h2 className="text-xl font-semibold tracking-wide">
//                             {selectedItem?.fullName}
//                         </h2>
//                     </div>
//                     <p className="mb-6 tracking-wide">
//                         Are you sure you want to Unblock this user?
//                     </p>
//                     <div className="flex justify-end space-x-4 tracking-wide">
//                         <button
//                             className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
//                             onClick={() => handleEditClose()}
//                         >
//                             Cancel
//                         </button>
//                         {
//                             idBtnLoading
//                                 ?
//                                 <button
//                                     className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded"
//                                 >
//                                     <BtnLoader />
//                                 </button>
//                                 :
//                                 <button
//                                     className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded"
//                                     onClick={() => handelSubmit()}
//                                 >
//                                     Unblock
//                                 </button>
//                         }
//                     </div>
//                 </div>
//             </Box>
//         </Modal>
//     );
// }

// export default EditPopUp;